// React import
import * as React from 'react';
// Standard layout imports
import Title from 'src/components/Title';
import Box from 'src/components/Box';
import { Link, Redirect } from 'react-router-dom';
import MyPageComingCourses from './myPageComingCourses.component';
import MyPageCourseEvaluations from './myPageCourseEvaluations.component';
import MyPageLearningPortalLink from './myPageLearningPortalLink.component';
import { connect } from 'react-redux';
import { UserSelector } from 'src/Entities/User/User.Selector';
import { IActivityModel } from 'src/Entities/Activity/Activity';
import { IComingCourses } from 'src/Entities/User/User';
import { Dispatch, Action } from 'redux';
import { setSlecetedActivtyAction } from 'src/Entities/PortalState/PortalState.Actions';

interface IProps {
  userComingActivities: IComingCourses[];
  setSelectedActivity: (detailKursusId: number) => void;
}
interface IState {
  shouldRedirect: boolean;
}
class MyPageInfo extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = { shouldRedirect: false };
    this.renderUserActivities = this.renderUserActivities.bind(this);
    this.goToActivity = this.goToActivity.bind(this);
  }
  public goToActivity(detailkursusId: number) {
    this.props.setSelectedActivity(detailkursusId);
    this.setState(Object.assign(this.state, { shouldRedirect: true }));
  }

  public renderUserActivities() {
    const { userComingActivities } = this.props;

    return (
      <div className="mb4">
        <Title className="mb2">Min Side</Title>
        <MyPageComingCourses
          comingActivities={userComingActivities}
          showSmallComponent={true}
          setSelectedActivity={this.goToActivity}
        />
        {this.state.shouldRedirect ? (
          <Redirect to="/kursus" push={true} />
        ) : null}
      </div>
    );
  }

  public render() {
    return (
      <div>
        {this.renderUserActivities()}
      </div>
    );
  }
}
function mapStateToProps(state: any, ownProps: any) {
  return {
    userComingActivities: UserSelector.getUserComingCourses()
  };
}
function mapDispatchToProps(dispatch: Dispatch<Action<any>>, ownProps: any) {
  return {
    setSelectedActivity: (detailkursusId: number) =>
      dispatch(setSlecetedActivtyAction(detailkursusId.toString()))
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(MyPageInfo);



// WEBPACK FOOTER //
// ./src/Pages/CoursePortal/MyPage/myPageInfo.component.tsx